import React from 'react';

export default function InfoTooltip({ label, children, width = 288, align = 'center', trigger }) {
  const containerAlign =
    align === 'right' ? 'right-0' :
    align === 'left' ? 'left-0' :
    align === 'responsive' ? 'left-1/2 -translate-x-1/2 min-[560px]:left-auto min-[560px]:translate-x-0 min-[560px]:right-0' :
    'left-1/2 -translate-x-1/2';
  const arrowAlign =
    align === 'right' ? 'right-1.5' :
    align === 'left' ? 'left-1.5' :
    align === 'responsive' ? 'left-1/2 -translate-x-1/2 min-[560px]:left-auto min-[560px]:translate-x-0 min-[560px]:right-1.5' :
    'left-1/2 -translate-x-1/2';
  const defaultTrigger = (
    <svg
      className="w-3.5 h-3.5 text-gray-400 dark:text-gray-500 group-hover:text-gray-600 dark:group-hover:text-gray-300 cursor-help transition"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      role="img"
      aria-label={label ? `About ${label}` : 'More info'}
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  );
  return (
    <span className="group relative inline-flex shrink-0">
      {trigger ?? defaultTrigger}
      <span
        role="tooltip"
        style={{ width: `min(${width}px, calc(100vw - 2rem))` }}
        className={`absolute ${containerAlign} bottom-full mb-2 pointer-events-none opacity-0 group-hover:opacity-100 group-hover:pointer-events-auto transition-opacity duration-200 z-[9999] max-w-[calc(100vw-2rem)]`}
      >
        <span className="relative block bg-gray-900 text-gray-100 text-sm leading-relaxed rounded-lg px-4 py-3 shadow-2xl border border-white/20 whitespace-normal text-left font-normal normal-case break-words">
          {children}
          <span className={`absolute top-full ${arrowAlign} -mt-px w-0 h-0 border-[6px] border-transparent border-t-gray-900`} />
        </span>
      </span>
    </span>
  );
}
